'use client'

import { Fragment, memo, useEffect, useRef } from 'react'

import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import { Button } from '@nextui-org/button'
import { useLogout } from '@privy-io/react-auth'
import { Skeleton } from '@nextui-org/react'
import { useDisclosure } from '@nextui-org/modal'
import { TelegramShareButton, TwitterShareButton } from 'react-share'

import SVGS from '@/assets/svgs'
import { PATHS } from '@/config/path'
import { useAppDispatch, useAppSelector, useQueryScreen } from '@/hooks'
import useClickOutside from '@/hooks/useClickOutside'
import { authActions } from '@/redux/reducers/auth/auth.reducer'
import { settingsActions } from '@/redux/reducers/settings/setting.reducer'
import { cn } from '@/utils/cn'
// import { PostContext } from '@/app/(global)/post-cre/components/TextareaPostProvider'
// import { ModalCreatePost } from '@/components/modals/ModalCreatePost'
import ICONS from '@/assets/icons'
import { ModalBecomeKOL } from '@/components/modals/ModalBecomeKOL'
import { useGetStatisticsReferralQuery } from '@/redux/api/wallet/wallet.apiw3'

import Account from '../Account'
import { ItemMenuData, ItemMenuDataMobile, ItemMenuMoreData } from '../constants'
import BtnOpenSideBar from './components/BtnOpenSideBar'
import InviteCode from './components/InviteCode'
import { checkMotion } from './constants'
import styles from './styles.module.css'
import { ItemMenuType } from './components/MenuType/ItemMenuType'
// import { DropdownMenuType } from './components/MenuType/DropdownMenuType'
import UserBottomSidebar from './components/UserBottomSidebar'
// import { SearchComponent } from '../SearchHeadBar/SearchComponent'

// const AddPostSidebar = () => {
//   const { isCompleted } = useContext(PostContext) || {}
//   const [isOpen, setIsOpen] = useState(false)

//   useEffect(() => {
//     if (isCompleted) {
//       setIsOpen(false)
//     }
//   }, [isCompleted])
//   return (
//     <Fragment>
//       <Button
//         onClick={() => setIsOpen(!isOpen)}
//         className="mt-4 hidden w-full bg-ss-primary text-sm font-medium text-white xl:block"
//         variant="solid"
//       >
//         Post
//       </Button>
//       <ModalCreatePost isOpen={isOpen} onTonggle={() => setIsOpen(!isOpen)} />
//     </Fragment>
//   )
// }

const SideBar: React.FC = memo(() => {
  const pathname = usePathname()

  const sidebarRef = useRef<HTMLDivElement>(null)
  const isPc = useQueryScreen('lg')
  const router = useRouter()
  const dispatch = useAppDispatch()
  const role = useAppSelector((state) => state.root.auth.user?.role) as any
  const user = useAppSelector((state) => state.root.auth.user)
  const menu = useAppSelector((state) => state.root.settings.menu)
  const spaceActive = useAppSelector((state) => state.root.settings.spaceActive)
  const isVariantsMotion = checkMotion({ checkIsDesktop: isPc, menu })
  const { isOpen, onClose, onOpen } = useDisclosure()

  const classAside = isPc && !menu ? styles.sidebarLayoutHidden : styles.sidebarLayout
  const checkCloseSidebarDesktop = isPc && !menu

  const { data, isLoading } = useGetStatisticsReferralQuery({})
  const bonus = data?.promotion.referralConfig.referralBonus || []
  const lastBonus = bonus.at(-1)

  const { logout } = useLogout({
    onSuccess: () => {
      dispatch(authActions.logout())
      dispatch(settingsActions.setActiveSpace(''))
      router.push('/sign-in')
    },
  })

  useClickOutside(sidebarRef, () => {
    if (!isPc) {
      dispatch(settingsActions.setMenu(false))
    }
  })

  useEffect(() => {
    dispatch(settingsActions.setMenu(isPc))
  }, [isPc])

  if (checkCloseSidebarDesktop) {
    return <BtnOpenSideBar />
  }

  return (
    <Fragment>
      <motion.aside ref={sidebarRef} className={cn(classAside, 'customScrollbar')} {...isVariantsMotion}>
        <div className={`${checkCloseSidebarDesktop && 'hidden'}`}>
          <div>
            {isPc ? (
              <Link href={'/feed'} className="mb-4">
                <Image src={SVGS.sightseaWhite} width={176} height={40} alt="sightsea" />
              </Link>
            ) : (
              <Account />
            )}
          </div>

          {/* <div className={cn('my-3', isPc ? 'hidden' : '')}>
            <SearchComponent
              debounceSecond={1}
              handleSearch={(value) => {
                if (value) {
                  router.replace(`/explore?search=${value?.trim()}`)
                  dispatch(settingsActions.setMenu(false))
                }
              }}
            />
          </div> */}

          <div>
            {isPc
              ? ItemMenuData.map((item: any) => {
                  // if (item.type == 'dropdown') return <DropdownMenuType item={item} key={item.id} />
                  if (item.id === 7) {
                    if (spaceActive) {
                      item.label = 'Your Space'
                      item.path = '/my-space'
                    } else {
                      item.label = 'Profile'
                      item.path = '/profile'
                    }
                  }
                  if (item.type == 'item') return <ItemMenuType item={item} key={item.id} />
                })
              : ItemMenuDataMobile.map((item: any) => {
                  // if (item.type == 'dropdown') return <DropdownMenuType item={item} key={item.id} />
                  if (item.id === 1) {
                    if (spaceActive) {
                      item.label = 'Your Space'
                      item.path = '/my-space'
                    } else {
                      item.label = 'Profile'
                      item.path = '/profile'
                    }
                  }
                  if (item.type == 'item') return <ItemMenuType item={item} key={item.id} />
                })}
          </div>

          {/* <TextareaPostProvider>
            <AddPostSidebar />
          </TextareaPostProvider> */}
          {role?.value !== 'kol' && (
            <div className="mt-4">
              <Button disabled={user?.isKOLSubmitting} onPress={() => onOpen()} className="bg-gradient-main w-full">
                Become KOL
              </Button>
            </div>
          )}
        </div>

        <div className={styles.groupBottomSideBar}>
          <div className="hidden w-full lg:block">
            {ItemMenuMoreData.filter((it) => !it.isMobile).map((item) => {
              const isActive = pathname === item.path
              return (
                <Link
                  prefetch={true}
                  target="_blank"
                  href={item.path}
                  key={item.id}
                  className={cn('flex gap-3 py-3', isActive ? styles.activeItem : styles.itemMenu)}
                  onClick={() => {
                    if (item.path === PATHS.SIGNIN) {
                      logout()
                    }
                  }}
                >
                  <Image
                    src={item.icon}
                    alt={item.label}
                    width={24}
                    height={24}
                    className={styles.iconMenu}
                    loading="lazy"
                  />
                  <p className="text-sm lg:text-base">{item.label}</p>
                </Link>
              )
            })}

            <div className="flex items-center justify-between">
              <p className="text-xs font-normal text-ss-grayscale-500 pb-2">Community</p>
              <div>
                <TelegramShareButton url={'https://t.me/sightseacommunity'} className="rounded-full">
                  <Image alt="" src={ICONS.icTeleW} width={24} height={24} />
                </TelegramShareButton>
                <TwitterShareButton url={'https://x.com/Sightsea_Tech'} className="rounded-full ml-4">
                  <Image alt="" src={ICONS.icXW} width={20} height={20} />
                </TwitterShareButton>
              </div>
            </div>
          </div>

          {!isPc && (
            <div className="w-full p-3 bg-ss-primary/10 rounded-xl space-y-3">
              <div className="space-y-2">
                <div className="text-sm">Refer Friends Earn SightSea Point</div>
                <div className="text-ss-grayscale-500 text-xs font-normal">
                  {!isLoading ? (
                    <>
                      When you reach {lastBonus?.milestone || 1000} referrals, you will receive{' '}
                      <span className="text-ss-accent-400">{lastBonus?.bonusPoints || 1500} SSP</span>.
                    </>
                  ) : (
                    <Skeleton className="h-5 w-full" />
                  )}
                </div>

                <div>
                  <Button
                    onPress={() => {
                      router.push('/wallet?tab=referral&category=leaderboard')
                      dispatch(settingsActions.setMenu(false))
                    }}
                    type="button"
                    className="w-full bg-gradient-main"
                  >
                    Leaderboard
                  </Button>
                </div>
              </div>
              <InviteCode />
            </div>
          )}
          {isPc && <UserBottomSidebar />}
          {!isPc && (
            <>
              <div className="self-start">
                <p className="text-xs font-normal text-ss-grayscale-500 pb-2">Community</p>
                <div className="flex items-center">
                  <Link target="_blank" href={'https://t.me/sightseacommunity'} className="rounded-full">
                    <Image alt="" src={ICONS.icTelegram2} width={24} height={24} />
                  </Link>
                  <Link target="_blank" href={'https://x.com/Sightsea_Tech'} className="rounded-full ml-4">
                    <Image alt="" src={ICONS.icX2} width={20} height={20} />
                  </Link>
                </div>
              </div>
              <div className="w-full text-center text-[10px] text-ss-grayscale-600 flex items-center justify-center gap-x-2">
                <Link className="text-ss-grayscale-600" href="/term-of-use" target="_blank">
                  Terms of Service
                </Link>{' '}
                <Link className="text-ss-grayscale-600" href="/privacy-policy" target="_blank">
                  Privacy Policy
                </Link>
                <p>@SightSea 2024</p>
              </div>
            </>
          )}
        </div>
      </motion.aside>
      {menu && !isPc && <div className="fixed right-0 top-0 z-[48] h-full w-full text-red-600 backdrop-blur-sm" />}
      <ModalBecomeKOL isOpen={isOpen} onClose={onClose} />
    </Fragment>
  )
})

export default SideBar
